import React, { useContext, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { IntlContext, useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ModalNextContext, Tooltip, Icon } from '@jutro/components';
import { DigitalWizardCustPageTemplate } from 'gw-portals-wizard-components-ui';
import {
    ViewModelServiceContext,
    withViewModelService,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import moment from 'moment';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { Contact, Claim } from 'gw-capability-fnol-common-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import metadata from './InjuryPage.metadata.json5';
import styles from './InjuryPage.module.scss';
import messages from '../../FNOLWC.messages';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';

function WCInjuryPage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        authHeader,
        history: {
            location: { state },
        },
    } = props;
    const { FNOLService } = useDependencies('FNOLService');
    const statusType = _.get(
        claimVM.value,
        'lobs.workersComp.employeeData.workStatus[0].workStatus'
    );
    const ModalNext = useContext(ModalNextContext);

    const translator = useTranslator();
    const { ClaimService } = useDependencies('ClaimService');

    const [toggleValue, setToggleValue] = useState(false);
    const [medicaltoggleValue, setMedicalToggleValue] = useState(false);
    const [isempty, setIsEmpty] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const [validityToggle, setValidityToggleValue] = useState();
    const [lossDateMessage, setLossDateMessage] = useState({});
    const [lastDayMessage, setLastDayMessage] = useState({});
    const [medicalExamDate, setMedicalExamDate] = useState({});
    const [reurnToWorkDate, setReturnToWorkDate] = useState({});
    const [disabilityBeginDate, setDisabilityBeginDate] = useState({});
    const [lossDateVal, setLossDateVal] = useState();
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation,
    } = useValidation('WCInjuryPage');

    useEffect(
        () => {

            const nextClaimVM = viewModelService.create(
                new Claim(claimVM.value),
                'cc',
                'edge.capabilities.claim.fnol.dto.FnolDTO',
                {
                    InjuryDetailsValidation: true,
                }
            );
            updateWizardData(nextClaimVM);
            setLossDateVal(claimVM.value.lossDate);
        },
        // only execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => {
        trackPageView('Injury Page', '/injury');
    }, []);

    useEffect(() => {
        trackGAPageView('/injury', 'FNOL Injury');
    }, []);

    const onNext = useCallback(() => {
        claimVM.value = new Claim(claimVM.value);

        const newClaimVM = _.clone(claimVM);

        _.set(newClaimVM, 'documents.value', []);
        _.set(newClaimVM, 'lossDate.value', lossDateVal);
        return FNOLService.saveFNOLDetails(newClaimVM.value, authHeader)
            .then(response => {
                claimVM.value = response;
                return claimVM;
            })
            .catch(() => {
                ModalNext.showAlert({
                    title: messages.fnolSaveDraftErrorTitle,
                    message: messages.fnolSaveDraftErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                //  setIsLoading(false);
            });
    }, [FNOLService, ModalNext, authHeader, claimVM, lossDateVal]);

    const handleValidity = useCallback(
        (value, path) => {
            if (value) {
                _.set(claimVM, path, value);
                updateWizardData(claimVM);
                setValidityToggleValue(value);
            }
            setValidityToggleValue(value);
            _.set(claimVM, path, value);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );
    // claimVM.lobs.workersComp.empQuesValidity = validityToggle;

    const handleAddAnInjury = useCallback(() => {
        setIsEmpty(true);

        // claimVM.lobs.workersComp.value.addBodyPartDetails();

        let bodyParts = [];
        if (
            claimVM.lobs.workersComp.injuryIncident.bodyParts &&
            claimVM.lobs.workersComp.injuryIncident.bodyParts.length > 0
        ) {
            bodyParts = claimVM.lobs.workersComp.injuryIncident.bodyParts.value;
        }

        bodyParts.push({
            tempID: EntityUtil.nextId(),
            primaryBodyPart: null,
            detailedBodyPart: null,
            detailedBodyPartDesc: null,
            sideOfBody: null,
            impairmentPercentage: null,
            firstBodyPart: false,
        });
        if (bodyParts !== 'undefined' && bodyParts[0] !== 'undefined') {
            bodyParts[0].firstBodyPart = true;
        }
        claimVM.lobs.workersComp.injuryIncident.bodyParts = bodyParts;

        updateWizardData(claimVM);
    }, [claimVM, updateWizardData, setIsEmpty]);

    if (
        isempty === true &&
        claimVM.lobs.workersComp.injuryIncident.bodyParts &&
        claimVM.lobs.workersComp.injuryIncident.bodyParts.length === 0
    ) {
        setIsEmpty(false);
    }

    if (
        claimVM.lobs.workersComp.injuryIncident.bodyParts &&
        claimVM.lobs.workersComp.injuryIncident.bodyParts.length > 0
    ) {
        const Bodyparts =
            claimVM.value.lobs.workersComp.injuryIncident.bodyParts;
        const visibility = Bodyparts.some(
            item => item.primaryBodyPart === null
        );
        if (visibility === false && isempty === true) {
            setIsEmpty(false);
        }
    }

    const handleRemoveAnInjury = useCallback(
        event => {
            const tabindex = parseInt(event.path.match(/[0-9]/gi), 10);
            const selectedObj =
                claimVM.lobs.workersComp.injuryIncident.bodyParts.value[
                    tabindex
                ];
            ModalNext.showConfirm({
                title: messages.wcInjuryRemoveBodyInjury,
                message: translator(messages.wcInjuryModalRemoveBodyInjury, {
                    bodyPartDetail: tabindex + 1,
                }),
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.wcInjuryRemoveButton,
                cancelButtonText: commonMessages.cancelMode,
            }).then(results => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }

                const indexToRemove = claimVM.lobs.workersComp.injuryIncident.bodyParts.value.findIndex(
                    exist => {
                        const tempIDMatches =
                            selectedObj.tempID &&
                            exist.tempID === selectedObj.tempID;
                        const publicIDMatches =
                            selectedObj.publicID &&
                            exist.publicID === selectedObj.publicID;
                        return tempIDMatches || publicIDMatches;
                    }
                );

                if (indexToRemove !== -1) {
                    claimVM.lobs.workersComp.injuryIncident.bodyParts.value.splice(
                        indexToRemove,
                        1
                    );
                }

                // claimVM.lobs.workersComp.value.removeBodyPartDetails(selectedObj);
                return updateWizardData(claimVM);
            }, _.noop);
        },
        [claimVM, ModalNext, translator, updateWizardData]
    );

    const isVisibleInjuryBodyPartDescription = useCallback(
        index => {
            const bodyPartsPath = `lobs.workersComp.injuryIncident.bodyParts.children[${index}]`;
            const detailedBodyPartDescAvailableVM = _.get(
                claimVM,
                bodyPartsPath
            );
            return (
                detailedBodyPartDescAvailableVM !== undefined &&
                !_.isEmpty(
                    _.get(
                        detailedBodyPartDescAvailableVM,
                        'detailedBodyPartDesc.aspects.availableValues'
                    )
                )
            );
        },
        [claimVM]
    );

    const updateBodyPart = useCallback(
        index => {
            const bodyPartsPath = `lobs.workersComp.injuryIncident.bodyParts.children[${index}]`;
            const primaryBodyPart = _.get(claimVM, bodyPartsPath);
            if (
                primaryBodyPart &&
                !_.isEmpty(_.get(primaryBodyPart.value, 'primaryBodyPart'))
            ) {
                return 'addBodyPart';
            }
        },
        [claimVM]
    );

    const updateAreaOfBody = useCallback(
        index => {
            const bodyPartsPath = `lobs.workersComp.injuryIncident.bodyParts.children[${index}]`;
            const bodyPart = _.get(claimVM, bodyPartsPath);
            if (
                bodyPart &&
                !_.isEmpty(_.get(bodyPart.value, 'detailedBodyPart'))
            ) {
                return 'areaOfBody';
            }
        },
        [claimVM]
    );

    const isVisibleInjuryBodyPartSide = useCallback(
        index => {
            const bodyPartsSideOfBodyPath = `lobs.workersComp.injuryIncident.bodyParts.children[${index}].sideOfBody`;
            const bodyPartsSideOfBodyVM = _.get(
                claimVM,
                bodyPartsSideOfBodyPath
            );
            return (
                bodyPartsSideOfBodyVM !== undefined &&
                bodyPartsSideOfBodyVM.aspects.required
            );
        },
        [claimVM]
    );

    const onChangeInjuryBodyPart = useCallback(
        (value, index) => {
            //  setIsEmpty(false);
            const bodyPartPath = `lobs.workersComp.injuryIncident.bodyParts.children[${index}]`;
            _.set(claimVM, `${bodyPartPath}.sideOfBody`, undefined);
            _.set(claimVM, `${bodyPartPath}.detailedBodyPartDesc`, undefined);
            _.set(claimVM, `${bodyPartPath}.detailedBodyPart`, value);
            _.set(claimVM, `${bodyPartPath}.dominant`, undefined);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const generateAddInjuryOverrides = useCallback(() => {
        const overrides = claimVM.lobs.workersComp.injuryIncident.bodyParts.children.map(
            (injured, index) => {
                return {
                    [`addInjuryTitleText${index}`]: {
                        value: translator(messages.wcInjuryBodyArea, {
                            bodyAreaCount: index + 1,
                        }),
                    },
                    [`removeInjuryTitleIcon${index}`]: {
                        // value: getDeleteIcon(index),
                        visible:
                            claimVM.lobs.workersComp.injuryIncident.bodyParts
                                .value.length !== 0,
                    },
                    [`wcInjuryBodyPart${index}`]: {
                        onValueChange: value => {
                            onChangeInjuryBodyPart(value, index);
                        },
                        labelClassName: updateBodyPart(index),
                    },
                    [`wcInjuryAreaOfBody${index}`]: {
                        labelClassName: updateAreaOfBody(index),
                    },
                    [`wcInjuryBodyPartDescription${index}`]: {
                        visible: isVisibleInjuryBodyPartDescription(index),
                    },
                    [`wcInjuryBodyPartSide${index}`]: {
                        visible: isVisibleInjuryBodyPartSide(index),
                    },
                    [`wcInjuryBodyPartDominant${index}`]: {
                        visible: isVisibleInjuryBodyPartSide(index),
                    },
                };
            }
        );

        return Object.assign({}, ...overrides);
    }, [
        claimVM,
        translator,
        updateBodyPart,
        updateAreaOfBody,
        isVisibleInjuryBodyPartDescription,
        isVisibleInjuryBodyPartSide,
        onChangeInjuryBodyPart,
    ]);

    const addDoctor = useCallback(() => {
        claimVM.lobs.workersComp.firstIntakeDoctor = new Contact({
            subtype: 'Doctor',
        });
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    const removeDoctor = useCallback(() => {
        claimVM.lobs.workersComp.firstIntakeDoctor = null;
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData]);

    const handleMedicalAttention = useCallback(
        (value, path) => {
            if (value) {
                setMedicalToggleValue(value);
                _.set(claimVM, path, value);
                updateWizardData(claimVM);

                return addDoctor();
            }
            setMedicalToggleValue(false);
            _.set(claimVM, path, value);
            updateWizardData(claimVM);
            return removeDoctor();
        },
        [addDoctor, claimVM, removeDoctor, updateWizardData]
    );
    const handleWorkStatus = useCallback(
        (value, path) => {
            if (value) {
                const workArray = [];
                workArray.push({
                    tempID: EntityUtil.nextId(),
                    workStatus: null,
                });
                claimVM.lobs.workersComp.employeeData.workStatus = workArray;
                _.set(claimVM, path, value);
                updateWizardData(claimVM);
                setToggleValue(value);
            }
            setToggleValue(value);
            _.set(claimVM, path, value);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const handleError = useCallback((title, message) => {
        return ModalNext.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
        }).catch(_.noop);
    }, []);

    const claimsDocUploadToken = useCallback(async () => {
        try {
            const uploadTokenID = await ClaimService.claimsDocUploadToken(
                [],
                authHeader
            );
            return uploadTokenID;
        } catch (e) {
            return handleError(
                commonMessages.errorUploadTitle,
                commonMessages.errorGenerateUploadToken
            );
        }
    }, [ClaimService, authHeader, handleError]);

    const onPrevious = async () => {
        await claimsDocUploadToken();
    };

    const intl = useContext(IntlContext);

    const getLastWorkedValidation = useCallback(
        e => {
            const dt = document.querySelector(
                'input[id^="wcInjuryLastWorked"]'
            );
            const date = dt.getAttribute('value');
            const dateFormat = 'MM-DD-YYYY';
            const toDateFormat = moment(new Date(date)).format(dateFormat);
            const InjuryDate = moment(lossDateVal).format(dateFormat);
            const today = moment(new Date()).format(dateFormat)
          

            if (toDateFormat !== 'Invalid date') {
                if (moment(toDateFormat) < moment(InjuryDate) || moment(toDateFormat) > moment(today)) {
                    if (
                        moment(
                            date,
                            [
                                'MM/DD/YYYY',
                                'M/D/YYYY',
                                'MM/D/YYYY',
                                'M/DD/YYYY',
                            ],
                            true
                        ).isValid() === false
                    ) {
                        const message = () => {
                            return (
                                <>
                                    <div>
                                    Please select a date between the Date of Injury and today.
                                    </div>
                                    <div>
                                        Date must be in the correct format:
                                        MM/DD/YYYY
                                    </div>
                                </>
                            );
                        };
                        setLastDayMessage(message);
                    } else {
                        setLastDayMessage(
                            'Please select a date between the Date of Injury and today.'
                        );
                    }
                } else {
                    setLastDayMessage('');
                }
            }
            if (toDateFormat === 'Invalid date') {
                setLastDayMessage(
                    'Date must be in the correct format: MM/DD/YYYY'
                );
            }
        },
        [lossDateVal]
    );
    const getDayDisabilityValidation = useCallback(
        e => {
            const dt = document.querySelector(
                'input[id^="wcInjuryDisabilityBegan"]'
            );
            const dtRet = document.querySelector(
                'input[id^="wcInjuryReturnToWork"]'
            );
            const date = dt.getAttribute('value');
            const dateReturnWork = dtRet.getAttribute('value');
            const dateFormat = 'MM-DD-YYYY';
            const toDateFormat = moment(new Date(date)).format(dateFormat);
            const dateReturnWorkFormat = moment(new Date(dateReturnWork)).format(dateFormat);
            // const lossDate = moment.utc(
            //     lossDateVal.toLocaleString()
            // );

            const InjuryDate = moment(lossDateVal).format(dateFormat);
            const today = moment(new Date()).format(dateFormat)

            if (toDateFormat !== 'Invalid date') {
                if (moment(toDateFormat) < moment(InjuryDate) || moment(toDateFormat) > moment(today)) {
                    if (
                        moment(
                            date,
                            [
                                'MM/DD/YYYY',
                                'M/D/YYYY',
                                'MM/D/YYYY',
                                'M/DD/YYYY',
                            ],
                            true
                        ).isValid() === false
                    ) {
                        const message = () => {
                            return (
                                <>
                                    <div>
                                    Please select a date between the Date of Injury and today.
                                    </div>
                                    <div>
                                        Date must be in the correct format:
                                        MM/DD/YYYY
                                    </div>
                                </>
                            );
                        };
                        setDisabilityBeginDate(message);
                    } else {
                        setDisabilityBeginDate(
                            'Please select a date between the Date of Injury and today.'
                        );
                    }
                } else {
                    setDisabilityBeginDate('');
                }
            }
            if (toDateFormat === 'Invalid date') {
                setDisabilityBeginDate(
                    'Date must be in the correct format: MM/DD/YYYY'
                );
            }
            if (moment(toDateFormat) > moment(dateReturnWorkFormat)) {
                if (
                    moment(
                        date,
                        [
                            'MM/DD/YYYY',
                            'M/D/YYYY',
                            'MM/D/YYYY',
                            'M/DD/YYYY',
                        ],
                        true
                    ).isValid() === false
                ) {
                    const message = () => {
                        return (
                            <>
                                <div>
                                Please select a date after or same as the Day Disability Began.
                                </div>
                                <div>
                                    Date must be in the correct format:
                                    MM/DD/YYYY
                                </div>
                            </>
                        );
                    };
                    setReturnToWorkDate(message);
                } else {
                    setReturnToWorkDate(
                        'Please select a date after or same as the Day Disability Began.'
                    );
                }
            } else {
                setReturnToWorkDate('');
            }
        },
        [lossDateVal]
    );

    const getDayReturnToWorkValidation = useCallback(
        e => {
            const dt = document.querySelector(
                'input[id^="wcInjuryReturnToWork"]'
            );
            const dtDis = document.querySelector(
                'input[id^="wcInjuryDisabilityBegan"]'
            );
            const date = dt.getAttribute('value')
            const disablityBegan = dtDis.getAttribute('value')
            const dateFormat = 'MM-DD-YYYY';        
            const toDateFormat = moment(new Date(date)).format(dateFormat);
            const disablityBeganFormat = moment(new Date(disablityBegan)).format(dateFormat);
            const today = moment(new Date()).format(dateFormat)
            // const lossDate = moment.utc(
            //     lossDateVal.toLocaleString()
            // );

            const InjuryDate = moment(lossDateVal).format(dateFormat);

            if (dt.value === '') {
                setReturnToWorkDate('');
            }
            if (toDateFormat !== 'Invalid date') {
                if (moment(disablityBeganFormat) > moment(toDateFormat)) {
                    if (
                        moment(
                            date,
                            [
                                'MM/DD/YYYY',
                                'M/D/YYYY',
                                'MM/D/YYYY',
                                'M/DD/YYYY',
                            ],
                            true
                        ).isValid() === false
                    ) {
                        const message = () => {
                            return (
                                <>
                                    <div>
                                    Please select a date after or same as the Day Disability Began.
                                    </div>
                                    <div>
                                        Date must be in the correct format:
                                        MM/DD/YYYY
                                    </div>
                                </>
                            );
                        };
                        setReturnToWorkDate(message);
                    } else {
                        setReturnToWorkDate(
                            'Please select a date after or same as the Day Disability Began.'
                        );
                    }
                } else {
                    setReturnToWorkDate('');
                }
            }
            if (toDateFormat === 'Invalid date' && dt.value !== '') {
                setReturnToWorkDate(
                    'Date must be in the correct format: MM/DD/YYYY'
                );
            }
        },
        [lossDateVal]
    );

    if (
        claimVM.value.lobs.workersComp.medicalReport &&
        medicaltoggleValue === false &&
        claimVM.value.onFastTrack === false
    ) {
        setMedicalToggleValue(true);
    }

    const validateStartDate = useCallback((e, start) => {
        let dt;
        if (start === 'startDate') {
            dt = document.querySelector(
                'input[id^="wcInjuryWorkStatusstartDate"]'
            );
            const date = dt.getAttribute('value');
            const dateFormat = 'MM-DD-YYYY';
            const toDateFormat = moment(new Date(date)).format(dateFormat);
           
            if(date==='')
            {
                setLossDateMessage('')
            }
            else if (
                moment(toDateFormat, dateFormat, true).isValid() === false ||
                    moment(
                        date,
                        ['MM/DD/YYYY', 'M/D/YYYY', 'MM/D/YYYY', 'M/DD/YYYY'],
                        true
                    ).isValid() === false
            ) {
                setLossDateMessage(
                    'Date must be in the correct format: MM/DD/YYYY'
                );
            } else {
                setLossDateMessage('');
            }
        } else if (start === 'InjuryExaminationDate') {
            dt = document.querySelector(
                'input[id^="wcInjuryDoctorExaminationDate"]'
            );
          
            const date = dt.getAttribute('value');
            const dateFormat = 'MM-DD-YYYY';
            const toDateFormat = moment(date).format(dateFormat);
          

            if (
                date !== '' &&
                (!moment(toDateFormat, dateFormat, true).isValid() )
            ) {
                setMedicalExamDate(
                    'Date must be in the correct format: MM/DD/YYYY'
                );
            } else {
                setMedicalExamDate('');
            }
        }
    }, []);

    const verifyLossDate = () => {
        if (!_.isEmpty(lossDateMessage)) {
            return [lossDateMessage];
        }
        return [];
    };

    const lastDayWorkedMessage = () => {
        if (!_.isEmpty(lastDayMessage)) {
            return [lastDayMessage];
        }
        return [];
    };
    const returnToWorkDate = () => {
        if (!_.isEmpty(reurnToWorkDate)) {
            return [reurnToWorkDate];
        }
        return [];
    };
    const medicalExamDateValidation = () => {
        if (!_.isEmpty(medicalExamDate)) {
            return [medicalExamDate];
        }
        return [];
    };
    const setDisabilityDate = () => {
        if (!_.isEmpty(disabilityBeginDate)) {
            return [disabilityBeginDate];
        }
        return [];
    };
  
  	const [inputErrors, setInputErrors] = useState({
        doctorName: "",
        doctorAddress: ""
    });	
  
  	const sanitizeInput = useCallback((value, field) => {
      const sanitized = value?.replace(/[;,]/g, "") || "";
      if (value && value !== sanitized) {
          setInputErrors(prev => ({
              ...prev,
              [field]: "Semicolons (;) and commas (,) are not allowed."
          }));
         
          setTimeout(() => {
              setInputErrors(prev => ({ ...prev, [field]: "" }));
          }, 3000);
      } else if (!value || sanitized === value) {
          setInputErrors(prev => ({ ...prev, [field]: "" }));
      }
      return sanitized;
  	}, []);

    const handleDoctorNameChange = useCallback((value) => {
        const sanitized = sanitizeInput(value, 'doctorName');
        _.set(claimVM, 'lobs.workersComp.firstIntakeDoctor.primaryContactName', sanitized);
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData, sanitizeInput]);

    const handleDoctorAddressChange = useCallback((value) => {
        const sanitized = sanitizeInput(value, 'doctorAddress');
        _.set(claimVM, 'lobs.workersComp.doctorInformation', sanitized);
        updateWizardData(claimVM);
    }, [claimVM, updateWizardData, sanitizeInput]);

    const preventInvalidChars = useCallback((event) => {
        if (event.key === ';' || event.key === ',') {
            event.preventDefault();
        }
    }, []);
  
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            tablet: {
                labelPosition: 'top',
            },
            phoneWide: {
                labelPosition: 'top',
            },
        },
        wcInjuryMedicalAttentionRequired: {
            onValueChange: handleMedicalAttention,
        },
        wcInjuryDoctorDetailsSection: {
            visible:
                medicaltoggleValue === true &&
                _.get(claimVM.value, 'onFastTrack') === false,
        },
		wcInjuryDoctorFirstName: {
            onValueChange: handleDoctorNameChange,
            onKeyDown: preventInvalidChars,
            validationMessages: inputErrors.doctorName ? [inputErrors.doctorName] : []
        },
        wcInjuryDoctorAddress: {
            onValueChange: handleDoctorAddressChange,
            onKeyDown: preventInvalidChars,
            validationMessages: inputErrors.doctorAddress ? [inputErrors.doctorAddress] : []
        },
        wcInjuryWorkTimeLost: {
            onValueChange: handleWorkStatus,
        },
        wcInjuryDoctorExaminationDate: {
            onBlur: e => validateStartDate(e, 'InjuryExaminationDate'),
            validationMessages: medicalExamDateValidation(),
        },
        WcInjuryWorkStatus: {
            visible:
                claimVM.value.lobs.workersComp.timeLossReport !== null &&
                claimVM.value.lobs.workersComp.timeLossReport === true,
        },
        wcBodyInjuryDetailsContainer: {
            visible: !_.get(claimVM.value, 'onFastTrack'),
        },
        injuryBefore: {
            visible: isempty,
        },
        wcInjuryDescription: {
            visible: !_.get(claimVM.value, 'onFastTrack'),
        },
        wcInjuryResultInDeath: {
            visible: !_.get(claimVM.value, 'onFastTrack'),
        },
        wcInjuryWorkStatusstartDate: {
            visible:
                (_.get(claimVM.value, 'lobs.workersComp.timeLossReport') &&
                    (statusType === 'fullduty' ||
                        statusType === 'restricted_work')) ||
                false,
            onBlur: e => validateStartDate(e, 'startDate'),
            validationMessages: verifyLossDate(),
        },
        wcInjuryLastWorked: {
            validationMessages: lastDayWorkedMessage(),
            onBlur: e => getLastWorkedValidation(e),
            visible:
                (_.get(claimVM.value, 'lobs.workersComp.timeLossReport') &&
                    statusType === 'stopped_work') ||
                false,
        },
        wcInjuryDisabilityBegan: {
            visible:
                (_.get(claimVM.value, 'lobs.workersComp.timeLossReport') &&
                    statusType === 'stopped_work') ||
                false,
            onBlur: e => getDayDisabilityValidation(e),
            validationMessages: setDisabilityDate(),
        },
        wcInjuryInjuryValidity: {
            onValueChange: handleValidity,
            value: _.get(
                claimVM.value,
                'lobs.workersComp.empQuesValidity',
                validityToggle
            ),
        },
        wcInjuryReturnToWork: {
            visible:
                (_.get(claimVM.value, 'lobs.workersComp.timeLossReport') &&
                    statusType === 'stopped_work') ||
                false,
            onBlur: e => getDayReturnToWorkValidation(e),
            validationMessages: returnToWorkDate(),
        },
        wcInjuryAlteredShedule: {
            visible:
                (_.get(claimVM.value, 'lobs.workersComp.timeLossReport') &&
                    statusType === 'restricted_work') ||
                false,
        },
        wcInjuryWorkStatusComments: {
            visible:
                (_.get(claimVM.value, 'lobs.workersComp.timeLossReport') &&
                    (statusType === 'stopped_work' ||
                        statusType === 'fullduty')) ||
                false,
        },

        ...generateAddInjuryOverrides(),
    };

    const resolvers = {
        resolveClassNameMap: styles,

        resolveComponentMap: {},
        resolveCallbackMap: {
            handleWorkStatus: handleWorkStatus,
            handleAddAnInjury: handleAddAnInjury,
            handleRemoveAnInjury: handleRemoveAnInjury,
            handleMedicalAttention: handleMedicalAttention,
        },
    };

    const { claimStatus } = state || {};

    const validateClaimStatus = useCallback(() => {
        return (
            !_.isNil(claimStatus) &&
            !!_.get(claimVM, 'lossLocation.city.value') &&
            claimStatus ===
                translator({
                    id: 'typekey.ClaimState.draft',
                    defaultMessage: 'Draft',
                })
        );
    }, [claimStatus, claimVM, translator]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [registerInitialComponentValidation, validateClaimStatus]);

    return (
        <WizardPage
            cancelLabel={translator(messages.fnolSaveandExit)}
            skipWhen={initialValidation}
            disableNext={!isComponentValid}
            onNext={onNext}
            onPrevious={onPrevious}
            showPrevious
            template={DigitalWizardCustPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

WCInjuryPage.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func,
    }).isRequired,
};

WCInjuryPage.propTypes = wizardProps;
export default withRouter(
    withViewModelService(withAuthenticationContext(WCInjuryPage))
);
